import * as services from 'services/recursosGluster.services';

export const getRecurso = async (payload) => {
  try {
    const resources = await services.fetchRecursoArchivo(payload);
    return { success: true, resources };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};

export const getListFiles = async (payload) => {
  try {
    const { data } = await services.fetchListaArchivos(payload);
    if (data?.code === 200) {
      const documentList = data?.document?.map(({ id, name, directory, emptyDirectory }) => ({
        key: id,
        title: name,
        isLeaf: !directory,
        emptyDirectory
      }));
      return { success: true, documentList };
    }
    return { success: false, documentList: [], message: data?.message };
  } catch (error) {
    console.error('Error', error);
    return { success: false, message: 'Hubo un error en la petición, revisa los datos' };
  }
};

export const addFiles = async (payload) => {
  try {
    const { data } = await services.fetchAgregaArchivos(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.log('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición, revisa porfavor.' };
  }
};

export const editFileName = async (payload) => {
  try {
    const { data } = await services.fetchEditaArchivo(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.log('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición, revisa porfavor.' };
  }
};

export const deleteFile = async (payload) => {
  try {
    const { data } = await services.fetchEliminaArchivos(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición' };
  }
};

export const deleteMonitoreos = async (payload) => {
  try {
    const { data } = await services.fetchEliminaMonitoreos(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición' };
  }
};

export const deleteDownloads = async (payload) => {
  try {
    const { data } = await services.fetchEliminaDescargas(payload);
    if (data?.code === 200) {
      return { success: true, message: data.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición' };
  }
};

export const deleteTemps = async (payload) => {
  try {
    const { data } = await services.fetchEliminaArchivosTemp(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición' };
  }
};

export const makeDirectory = async (payload) => {
  const request = { pathCrearCarpeta: payload };
  try {
    const { data } = await services.fetchCreaCarpeta(request);
    if (data?.code === 200) {
      return { success: true, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'hubo un error en la petición' };
  }
};

export const downloadFiles = async (payload) => {
  try {
    const { data } = await services.fetchDescarga(payload);
    if (data?.code === 200) {
      return { success: true, file: data.archivo, message: data?.message };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error: ', error);
    return { success: false, message: 'Hubo un error en la petición' };
  }
};

export const massiveDownload = async (payload) => {
  try {
    const { data } = await services.fetchDescargaZip(payload);
    if (data?.code === 200) {
      return { success: true, message: data?.message, file: data?.resource };
    }
    return { success: false, message: data?.message };
  } catch (error) {
    console.error('Hubo un error en la petición: ', error);
    return { success: false };
  }
};
